/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateColorDto } from '../models/CreateColorDto';
import type { UpdateColorDto } from '../models/UpdateColorDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ColorsService {
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static colorsControllerCreate(
        requestBody: CreateColorDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/colors',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all colors
     * @param page Page number
     * @param limit Items per page
     * @param searchName Search by color name
     * @returns any Returns all colors
     * @throws ApiError
     */
    public static colorsControllerFindAll(
        page?: number,
        limit?: number,
        searchName?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/colors',
            query: {
                'page': page,
                'limit': limit,
                'searchName': searchName,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static colorsControllerFindOne(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/colors/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static colorsControllerUpdate(
        id: string,
        requestBody: UpdateColorDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/colors/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a color
     * @param id
     * @returns any Color deleted successfully
     * @throws ApiError
     */
    public static colorsControllerRemove(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/colors/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Cannot delete color - it is being used by products`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Color not found`,
            },
        });
    }
}
